/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestResultWithExtraData } from './AutoTestResultWithExtraData';
const AllAutoTestResultsParser = /* #__PURE__ */ parsers.object([
    ['totalAmount', codecNumber, 'total_amount'],
    ['results', /* #__PURE__ */ codecArray(AutoTestResultWithExtraData)],
]);
export class AllAutoTestResults extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AllAutoTestResultsParser.decode(input).map(res => new AllAutoTestResults(res));
    }
    static unsafeDecode(input) {
        return AllAutoTestResults.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AllAutoTestResultsParser.encode(data);
    }
    static schema() {
        return AllAutoTestResultsParser.schema();
    }
}
